export const ONE_PLATFORM_ERROR = "ONE_PLATFORM_ERROR";
export const ONE_PLATFORM_HIDE_ERROR = "ONE_PLATFORM_HIDE_ERROR";
export const ONE_PLATFORM_START_LOADER = "ONE_PLATFORM_START_LOADER";
export const ONE_PLATFORM_STOP_LOADER = "ONE_PLATFORM_STOP_LOADER";
export const ONE_PLATFORM_ADD_MSG = "ONE_PLATFORM_ADD_MSG";
export const ONE_PLATFORM_CLEAR_MSG = "ONE_PLATFORM_CLEAR_MSG";
